import { ReactNode } from 'react';
import * as defaults from './defaults';
// Todo: Could we load these file dynamically? Have them in a separate folder maybe?
import * as nz from './nz';

interface NameValuePair<T> {
  name: string;
  value: T;
}

interface ITableHeader {
  name: string;
  id: string;
  sortable: boolean;
}

// TODO: review for unused constants
interface Constants {
  INCOME_FREQUENCIES_WITH_YEARLY: NameValuePair<string>[];
  LIVING_EXPENSES_TOOLTIP: string;
  LOAN_COUNT_DESCRIPTION: string;
  LOAN_COUNT_TOOLTIP: string;
  FINANCIAL_EXPENSES_TOOLTIP: string;
  RELATIONSHIP_STATUS: NameValuePair<string>[];
  DEPENDANTS_DROPDOWN: NameValuePair<string>[];
  HOUSEHOLD_INCOME_TOOLTIP: ReactNode;
  DEPENDANTS_TOOLTIP: ReactNode;
  RELATIONSHIP_STATUS_TOOLTIP: ReactNode;
  REGION_STATES?: NameValuePair<string>[];
  RESIDENTIAL_STATUS?: NameValuePair<string>[];
  TIME_IN_ADDRESS?: NameValuePair<string>[];
  CUSTOMER_TITLES?: NameValuePair<string>[];
  TIMEFRAMES: NameValuePair<number>[];
  TIME_IN_JOB?: NameValuePair<string>[];
  EMPLOYMENT_TYPES?: NameValuePair<string>[];
  BUSINESS_NUMBER?: string;
  INCOME_FREQUENCIES?: NameValuePair<string>[];
  MERCHANT_PLANS_TABLE_HEADERS: ITableHeader[];
  PAYMENT_FREQUENCIES: NameValuePair<string>[];
  PAYMENT_PERIODS?: NameValuePair<number>[];
  DEPOSIT_PERCENTAGES?: NameValuePair<number>[];
  INCOME_PERCENTAGES: NameValuePair<number>[];
  MONTHLY_PAYMENT_DATE_SELECTION?: NameValuePair<string>[];
  TITLE_VALIDATION_REGEX: RegExp;
  FIRSTNAME_VALIDATION_REGEX: RegExp;
  MIDDLENAME_VALIDATION_REGEX: RegExp;
  LASTNAME_VALIDATION_REGEX: RegExp;
  JOBTITLE_VALIDATION_REGEX: RegExp;
  EMAIL_VALIDATION_REGEX: RegExp;
  PHONE_VALIDATION_REGEX: RegExp;
  MOBILE_VALIDATION_REGEX: RegExp;
  LICENCE_VALIDATION_REGEX: RegExp;
  LICENCE_CARD_NUMBER_VALIDATION_REGEX: RegExp;
  RECORDS_PER_PAGE: number;
  LOAD_PER_PAGE: number;
  PLAN_APPROVED_STATUS?: string;
  LOAN_APPROVED_STATUS?: string;
  PLAN_PENDING_STATUS?: string;
  LOAN_PENDING_STATUS?: string;
  PLAN_NOT_FOUND?: string;
  PLAN_ACTIVATE?: string;
  LOAN_ACTIVATE?: string;
  RESEND_VERIFICATION_CODE: string;
  RESEND_APPLICATION_LINK: string;
  RESEND_CREDIT_SCHEDULE: string;
  STAFF_NOT_FOUND?: string;
  RATES_NOT_FOUND?: string;
  CONTACT_STATUS_WITH_COMPANY: string;
  CONTACT_STATUS_LEFT_COMPANY: string;
  PLAN_ACTIVATION_MODAL_TITLE: string;
  PLAN_FILTER_OPTIONS?: any;
  PASSWORD_STATUS?: string;
  READABLE_APPROVED_PENDING_ID: string;
  APPROVED_PENDING_ID: string;
  READABLE_APPROVED_STATEMENT_REQUESTED: string;
  APPROVED_STATEMENT_REQUESTED: string;
  APPROVED_BANK_STATEMENTS_REQUIRED?: string;
  EXISTING_CARD?: string;
  ADD_CARD?: string;
  IDENTIFICATION_YEARS: number;
  DOB_YEARS: number;
  STAFF_USER_NAME_INFO_TEXT?: string;
  SUCCESSFUL_PLAN_ACTIVATION: string;
  SUCCESSFUL_LOAN_ACTIVATION: string;
  PLAN_ACTIVATION_CONFIRMATION: string;
  LOAN_ACTIVATION_CONFIRMATION?: string;
  LOAN_ACTIVATION_MODAL_TITLE?: string;
  REQUEST_FAILURE: string;
  SUCCESSFUL_STAFF_CREATION: string;
  SUCCESSFUL_STAFF_UPDATE: string;
  UNSUCCESSFUL_STAFF_UPDATE: string;
  UNSUCCESSFUL_UPDATE: string;
  PLAN_FILTER_MESSAGE?: string;
  LOAN_FILTER_MESSAGE?: string;
  SUCCESSFUL_NEW_PLAN_APPROVED_TITLE: string;
  SUCCESSFUL_NEW_PLAN_APPROVED_BODY: string;
  SUCCESSFUL_RESEND_VERIFICATION_CODE: string;
  RESEND_VERIFICATION_CODE_CONFIRMATION: string;
  SUCCESSFUL_RESEND_APPLICATION_LINK: string;
  RESEND_APPLICATION_LINK_CONFIRMATION: string;
  SUCCESSFUL_RESEND_CREDIT_SCHEDULE: string;
  RESEND_CREDIT_SCHEDULE_CONFIRMATION: string;
  PASSWORD_SUCCESSFUL_TITLE: string;
  PASSWORD_NEXT_LOGIN?: string;
  SUCCESSFUL_FORGOT_PASSWORD_TITLE: string;
  SUCCESSFUL_FORGOT_PASSWORD_MESSAGE?: string;
  FAILURE_FORGOT_PASSWORD_MESSAGE: string;
  MESSAGE_SEND_APPLICATION_LINK_TO_CUSTOMER?: string;
  LABEL_SEND_TO_CUSTOMER_TO_COMPLETE?: string;
  LABEL_COMPLETER_ON_CUSTOMER_BEHALF?: string;
  SUCCESSFUL_PLAN_SENT_TO_CUSTOMER?: string;
  CUSTOMER_TYPE_NEW_CUSTOMER_TITLE: string;
  CUSTOMER_TYPE_EXISTING_CUSTOMER_TITLE: string;
  MERCHANT_MARKETING_CONSENT_TEXT: string;
  MERCHANT_MARKETING_CONSENT_TEXT_NZ: string;
  NEW_CUSTOMER_DETAIL?: string;
  SALE_DETAIL?: string;
  SUMMARY_DETAIL?: string;
  CUSTOMER_IDENTIFICATION?: React.ReactNode;
  MARKETING_CHECKBOX_TEXT?: string;
  PAYMENT_DETAIL_TEXT?: string;
  TOOLTIP_PLAN_DETAIL?: string;
  APPROVED_PAID_MESSAGE?: string;
  HEADER_MESSAGE_REVIEW?: string;
  HEADER_MESSAGE_DECLINED?: string;
  HEADER_MESSAGE_PENDING?: string;
  HEADER_MESSAGE_REQUEST?: string;
  HEADER_MESSAGE_PAYMENT_PLAN?: string;
  REVIEW_MESSAGE?: string | React.ReactNode;
  DECLINED_MESSAGE?: string;
  APPROVED_PENDING_ID_MESSAGE?: string;
  APPROVED_PENDING_ID_MESSAGE_2?: string;
  HELPDESK_EMAIL?: string;
  TELL_YOUR_CUSTOMER_LINK?: string;
  LABEL_STATE?: string;
  LABEL_SUBURB?: string;
  MOBILE_NUMBER_FORMAT_VALIDATION: string;
  PHONE_NUMBER_FORMAT_VALIDATION: string;
  CONTACT_US_PHONE_NUMBER_URL: string;
  CONTACT_US_PHONE_NUMBER: string;
  PAYRIGHT_MERCHANT_V1?: string;
  CUSTOMISE_LINK_TYPE?: NameValuePair<string>[];
  CHECKOUT_CODE_REGEX: RegExp;
  CHECKOUT_CODE_FORMAT_VALIDATION?: string;
  PLAN_LIST_PAGE_LIMIT: number;
  SUGAR_PLAN_STATUS_FOR_PRE_APPROVAL: string;
  RENAME_SUGAR_PLAN_STATUS_FOR_PRE_APPROVAL: string;
  LESS_THAN_6_MONTHS: string;
  UNSUCCESSFUL_DDO_UPDATE: string;
  CANCEL_POPUP_TITLE: string;
  CANCEL_POPUP_TEXT: string;
  CANCEL_POPUP_CANCEL_PLAN: string;
  CANCEL_POPUP_ABORT_CANCEL: string;
  LOAN_PURCHASE_DETAIL?: string;
  APPLICATION_SENT_TO_CUSTOMER?: string;
  SUCCESSFUL_LOAN_SENT_TO_CUSTOMER?: string;
}

const getConstants = (): Constants => {
  let constants: Constants = { ...defaults };

  if (!process.env.REACT_APP_REGION) {
    return constants;
  }

  // Todo: make more dynamic for other regions?
  if (process.env.REACT_APP_REGION.toLowerCase() === 'nz') {
    constants = { ...constants, ...nz };
  }

  return constants;
};

export default getConstants;
